import { createElement } from 'react'
import { createRoot } from 'react-dom/client'
import type { IAddNoticeProps } from './AddNotice'
import AddNotice from './AddNotice'

export async function showAddNotice(
  props: Omit<IAddNoticeProps, 'onClose' | 'onConfirm'>
): Promise<boolean> {
  return new Promise<boolean>((resolve) => {
    const mountDiv = document.createElement('div')
    document.body.append(mountDiv)

    const root = createRoot(mountDiv)

    root.render(
      createElement(AddNotice, {
        ...props,
        onConfirm: () => {
          resolve(true)
          root.unmount()
          mountDiv.remove()
        },
        onClose: () => {
          resolve(false)
          root.unmount()
          mountDiv.remove()
        },
      })
    )
  })
}
